import styled from "styled-components";
import {
  COLORS,
  responsive,
} from "../../../../../../../../styles/constants.style";

export const ViewProjectFeeExpenseModalContainer = styled.div`
  .container-box {
    width: 100%;
    margin: 10px 0 20px 0;
    ${responsive.MOBILE`
      margin: 0 0 0 0;
    `}
  }
  .container-header {
    margin-left: 20px;
    ${responsive.MOBILE`
      margin-left: 16px;
    `}
  }
  .general-info {
    margin-top: 10px;
  }
  .configuration-container {
    padding: 20px;
    ${responsive.MOBILE`
        padding: 16px;
    `}
    border-bottom: 1px dashed ${COLORS.primary_light_blue4};
  }
  .MuiGrid2-container:last-child .configuration-container {
    border-bottom: none;
  }
`;
